import { initializeApp } from "firebase/app";
import { getAnalytics, isSupported as analyticsSupported } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyCJItkrf5_ojcBQIqg6MK1XBzRtx2c0pyM",
  authDomain: "ro3k-learn.firebaseapp.com",
  projectId: "ro3k-learn",
  storageBucket: "ro3k-learn.firebasestorage.app",
  messagingSenderId: "205973871074",
  appId: "1:205973871074:web:56ea1fba4f12e31779c1bb",
  measurementId: "G-GJCRD3ECJE",
};

export const app = initializeApp(firebaseConfig);

export const analytics = (async () => {
  if (await analyticsSupported()) return getAnalytics(app);
  return null;
})();
